import api from '@/lib/api';

// Lightweight, fire-and-forget engagement tracking. Never blocks the UI and
// silently no-ops when the user is not authenticated.
const send = (event, payload) => {
  try {
    if (!localStorage.getItem('cocc_token')) return;
    api.post('/analytics/track', { event, ...payload }).catch(() => {});
  } catch (_) { /* ignore */ }
};

export const track = (event, meta = {}) => send(event, { meta });

export const trackPageView = (path) => send('page_view', { path });
